import { OptionalFeature } from "../../../../base/domain/drawing";
import { INaturalTextBehavior } from "./INaturalTextBehavior";

export class NaturalTextBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean   = false,
    public text: string = ""
  ) {
    super(isEnable);
  }

  clone(): NaturalTextBehavior {
    return new NaturalTextBehavior(this.isEnable, this.text);
  }

  static from(source: INaturalTextBehavior): NaturalTextBehavior {
    return new NaturalTextBehavior(source.isEnable, source.text);
  }

  static to(source: NaturalTextBehavior): INaturalTextBehavior {
    return {
      isEnable: source.isEnable,
      text: source.text,
    };
  }
}
